/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiInCategory
 */
export interface PoiInCategory {
    /**
     * 
     * @type {number}
     * @memberof PoiInCategory
     */
    categoryId: number;
}

export function PoiInCategoryFromJSON(json: any): PoiInCategory {
    return PoiInCategoryFromJSONTyped(json, false);
}

export function PoiInCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiInCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
    };
}

export function PoiInCategoryToJSON(value?: PoiInCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryId': value.categoryId,
    };
}


